export default {
  demo: {
    msg: "message",
  },
  common: {
    loadMore: "More News",
    btn: {
      reset: "reset",
      submit: "submit",
      cancel: "cancel",
    },
    require: "required",
    success: "success",
  },
  header: {
    home: "Home",
    about: "About Us",
    product: "Products",
    news: "News",
    investor: "投资者关系",
    services: "Services",
    search: "Document",
    mall: "Shopping Mall",
    aboutList: [
      { name: "Company Profile", url: "./about.html", id: 1 },
      { name: "Company History", url: "./history.html", id: 2 },
      { name: "Company Background", url: "./honor.html", id: 3 },
      { name: "Join Us", url: "./join.html", id: 4 },
    ],
    productList: [
      { name: "Chemical Reagents", url: "./product.html", id: 1 },
      { name: "Industrial Raw Materials ", url: "./material.html", id: 2 },
      { name: "New Energy Materials", url: "", id: 7 },
      // { name: "Chemicals For Daily Use", url: "./daily.html", id: 3 },
      // {name: "Health", url: "./health.html", id: 4},
      // {name: "Our Brand", url: "./brand.html", id: 5},
      // {name: "Internet", url: "./internet.html", id: 6},
    ],
    newsList: [
      { name: "Group News", url: "./news.html?type=0", id: 1 },
      { name: "Product Story", url: "./material.html", id: 2 },
      { name: "Video Center ", url: "./daily.html", id: 3 },
      { name: "Our Brands", url: "./brand.html", id: 4 },
    ],
    searchList: [
      { name: "COA", url: "./searchCoa.html", id: 1 },
      { name: "MSDS", url: "./searchMsds.html", id: 2 },
      { name: "SAFETY LABEL", url: "./searchSafetyLabel.html", id: 3 },
      { name: "TDS", url: "./searchTds.html", id: 4 },
    ],
    contactList: [
      { name: "Services", id: 1 },
      { name: "留言反馈", url: "./contact.html", id: 2 },
    ],
  },
  footer: {
    contact: "Contact Us",
    footerList: [
      {
        title: "About Xilong",
        url: "./about.html",
        id: 1,
        list: [
          {
            title: "Who Are We",
            url: "./about.html",
            id: "1-1",
          },
          {
            title: "Xilong History",
            url: "./history.html",
            id: "1-2",
          },
          {
            title: "Xilong Culture & Values",
            url: "./honor.html",
            id: "1-3",
          },
          {
            title: "Contact Us",
            url: "./join.html",
            id: "1-4",
          },
        ],
      },
      {
        title: "Product Center",
        url: "./product.html",
        id: 2,
        list: [
          {
            title: "Chemical Reagents",
            url: "./product.html",
            id: "2-1",
          },
          {
            title: "Industrial Raw Materials",
            url: "./material.html",
            id: "2-2",
          },
          {
            title: "New Energy Materials",
            url: "",
            id: "2-6",
          },
          // {
          //   title: "Chemicals For Daily Use",
          //   url: "./daily.html",
          //   id: "2-3",
          // },
          // {
          //   title: "Health",
          //   url: "./health.html",
          //   id: "2-3",
          // },
          // {
          //   title: "Private brand",
          //   url: "./brand.html",
          //   id: "2-4",
          // },
          // {
          //   title: "Internet",
          //   url: "./internet.html",
          //   id: "2-5",
          // },
        ],
      },
      // {
      //   title: "Investor Relations",
      //   url: "./gover.html",
      //   id: 3,
      //   list: [
      //     {
      //       title: "Stock Information",
      //       url: "./gover.html",
      //       id: "3-1",
      //     },
      //     {
      //       title: "Cooperate News",
      //       url: "http://www.cninfo.com.cn/new/disclosure/stock?stockCode=002584&orgId=9900019958#latestAnnouncement",
      //       id: "3-2",
      //     },
      //     {
      //       title: "Financial Reports",
      //       url: "http://www.csrc.gov.cn/",
      //       id: "3-3",
      //     },
      //     {
      //       title: "Investor resources",
      //       url: "https://ir.p5w.net/c/002584.shtml",
      //       id: "3-4",
      //     },
      //     {
      //       title: "Investor Interaction",
      //       url: "./onLine.html",
      //       id: "3-5",
      //     },
      //     {
      //       title: "Request information",
      //       url: "./onLine.html",
      //       id: "3-6",
      //     },
      //   ],
      // },
      {
        title: "Media",
        url: "./news.html",
        id: 4,
        list: [
          {
            title: "News Release",
            url: "./news.html?type=0",
            id: "4-1",
          },
          {
            title: "New Product Announcement",
            url: "./news.html?type=1",
            id: "4-2",
          },
          {
            title: "Media Library",
            url: "./news.html?type=2",
            id: "4-3",
          },
          {
            title: "Xilong Brands",
            url: "./brand.html",
            id: "4-4",
          },
        ],
      },
      {
        title: "Ecological Partner",
        url: "",
        id: 5,
        list: [
          {
            title: "JIAHE BIOTECH",
            url: "http://www.jiaheamino.com/",
            id: "5-1",
          },
        ],
      },
      // {
      //   title: "Network",
      //   url: "./service.html",
      //   id: 6,
      //   list: [],
      // },
    ],
    dangerlicense: "Dangerous Goods and Chemicals Business License",
    businesslicense: "Business License",
    contactUser: "Contact information: Manager Li 13544828089",
    address: "Address: 1st floor, Building B, Xilong Innovation Park, No. 6 Xinrui Road, Huangpu District, Guangzhou",
    company: "© Copyright 2020 Quantech (Guangzhou) New Materials Co.Ltd",
  },
  home: {
    companyTitle: "Our Company",
    companyDetail:
      "Quantech is located in Guangzhou and focuses on the research, production and service of high-end electronic chemicals to provide state-of-the-art electronic material solutions for integrated circuit manufacturing. With advanced production, R & D, and supporting testing equipment, including 300 mm wafer production equipment as well as level 10 and 100 clean plants, and managed with an MES system, quataic is one of the world's most advanced production and R & D bases for electronics, offering ultra-high purity electronic materials with the strictest quality assurance to the semiconductor industry.",
    productTitle: "Products&Services",
    newsTitle: "News",
    moreBtn: "More News",
    customTitle: "Our Customer",
    detail: "View Details",
  },
  product: {
    breadcrumbs: {
      title: "Product Center",
      title1: "Chemical Reagents",
      title2: "Industrial Raw Materials ",
      title3: "Chemicals For Daily Use",
      // title4: "Our brand",
      // title4: "Great Health",
      // title5: "Private Brand",
      // title6: "Internet",
    },
  },
  news: {
    breadcrumbs: {
      title: "News&Information",
      title1: "Group News",
      title2: "Product Story",
      title3: "Video Center",
      title4: "Our Brands",
    },
    detail: "Detail",
    pre: "previous page",
    next: "next page",
  },
  aboutUs: {
    breadcrumbs: {
      title1: "About XiLong",
      title2: "Company Profile",
      title3: "Enterprise Milestones",
      title4: "Company Background",
      title5: "Join Us",
    },
    tab: {
      tab1: "Xilong Introduction",
      tab2: "Enterprise Milestones",
      tab3: "Company Background",
      tab4: "Join Us",
    },
    introduce: "XILONG Introduction",
    companyName: "Xilong Scientific Co., Ltd",
    companyContent: `Xilong Scientific Co., Ltd.,  (referred to as "Xilong Scientific", stock code: 002584), formerly known as Xilong Chemical Co., Ltd. was founded in 1983, established as one of the largest chemical reagents manufacturers and suppliers, combining with R&D, import and export business, in China.<br>
    Xilong Scientific is the first chemical reagent producer to successfully enlisted IPO in China in June 2011.<br>
    The company mainly engages in the research and development, production, sales, and supporting services of fine chemicals and new materials, including general chemical reagents, PCB chemical reagents, ultra high-purity chemical reagents, wet electronic chemicals, industrial raw materials, food additives, photovoltaic electrode materials, Lithium battery positive electrode materials, etc.  <br>
    Xilong Scientific has over 8 production plant in different areas of China. Operating under ISO9001, ISO14001, and OHSAS18001, Xilong Scientific guarantees the quality and its production under environmental, professional health and safety management. <br>
    With a high qualified technical development and quality management team, Xilong Scientific is also devoted to new product development and technical innovation.`,
    corporateCulture: "Corporate Culture",
    culture: [
      {
        img: require("../assets/aem/yj.png"),
        img2: require("../assets/aem/yj2.png"),
        title: "Mission",
        intro: `Science strengthens happiness`,
      },
      {
        img: require("../assets/aem/sm.png"),
        img2: require("../assets/aem/sm2.png"),
        title: "Vision",
        intro: `Through precise customer services and the advanced service platform, we aim to cover ever aspect of the high-end smart manufacturing industry chain, including new energy and biopharmaceuticals, making us a leading specialist manufacturer and integrated supplier of fine chemicals and new materials.`,
      },
      {
        img: require("../assets/aem/jzg.png"),
        img2: require("../assets/aem/jzg2.png"),
        title: "Value",
        intro: `
        Energized Process<br>
        Innovative Pursuit<br>
        Integrity and Responsibility<br>
        Win-win Collaboration</li>`,
      },
    ],
    chairman: "Leadership Address",
    chaimanCon: `The development of Xilong Scientific’s business has consistently relied on talent and technology, 
    adhering to management and innovation. The company maintains a leading edge in research and development capabilities, marketing, 
    and brand influence, positioning itself as a prominent professional manufacturer and integrated supplier in the chemical reagents industry with strong R&D capabilities,
    extensive marketing network coverage, and significant brand influence.`,
    honor: {
      professional: "Professional Team",
      person: "Person",
      technician: "Technician",
      staff: "R&D personnel",
      master: "Doctoral and master’s degrees",
      teamIntroduction: `Establishing academicians' workstations and postdoctoral research workstations, 
      recruiting academicians, professors, experts, and scholars from renowned domestic and international universities and research institutions as technical advisors. 
      By bringing in overseas distinguished experts, outstanding young talents, leaders from the "Pearl River Talent Plan," key personnel from the "Ganren Plan," 
      and top-notch urgently needed talents from the "Yangfan Plan," we aim to lead the company's technological development towards internationalization, standardization, and high-end specialization.`,
      honor: "honor",
      des: {
        one: "Undertaking numerous national and provincial research projects, participating in the formulation of national standards and industry standards for chemical reagents.Serving as the Fine Chemical Engineering Research and Development Center in Guangdong Province, and establishing the Guangdong Province Industry-Academia-Research Hybrid Demonstration Base and Fine Chemical Research and Development Base. Additionally, designated as the Enterprise Technology Center, Postdoctoral Workstation, and Academicians' Workstation in Guangdong Province.",
      },
      item1: {
        one: "National Torch Program Project",
        two: "Spark Program Project",
        three: "15 key new product projects",
      },
      item2: {
        one: "Provincial Torch Program Project",
        two: "48 key new product projects",
      },
      item3: {
        one: "The company and its subsidiaries have 379 patents with independent intellectual property rights",
        two: "Among them, 49 invention patents",
      },
      item4: {
        one: "Provincial and ministerial level or above technology、",
        two: "112 innovative technological transformation projects",
      },
    },
    joinUs: {
      recruitment: "",
      tableHeade: [
        { name: "Recruitment Department", id: 0 },
        { name: "Position", id: 1 },
        { name: "Work Location", id: 2 },
        { name: "Release Date", id: 3 },
        { name: "Job Application", id: 4 },
      ],
      detail: "Detail",
      detailTab: {
        location: "Work Location",
        age: "Age",
        benefits: "Salary and benefits",
        date: "Release Date",
        experience: "Work Experience",
        education: "Education",
        num: "Recruiting Numbers",
        validity: "Position Validity Period",
      },
      responsibility: "responsibility",
      apply: "Apply now",
    },
  },
  network: {
    serviceNet: "Service Network",
    companyName: "Xilong Scientific Co., Ltd",
    address: "ADDRESS：1-3 Xilong Middle Street,Chaoshan Road, Shantou, Guangdong, China",
    telphone: "TELEPHONE：0754-82481166",
    zipcode: "ZIP CODE：515000",
    office: [
      {
        id: 1,
        list: [
          { name: "Shantou Base", tel: "0754-82493143", id: "1-1" },
          { name: "Guangzhou Company", tel: "020-6261 2188(382)", id: "1-2" },
          { name: "Sichuan Company", tel: "028-85431583", id: "1-3" },
          { name: "Shanghai Company", tel: "021-52907766", id: "1-4" },
          { name: "Shenyang Company", tel: "024-62265178", id: "1-5" },
          { name: "International Department", tel: "020-62612188", id: "1-6" },
          { name: "Zhongshan Office", tel: "0760-88612703", id: "1-7" },
        ],
      },
      {
        id: 2,
        list: [
          { name: "Beijing Office", tel: "010-59796198", id: "2-1" },
          { name: "Tianjin Office", tel: "022-24980521", id: "2-2" },
          { name: "Qingdao Office", tel: "0532-80971508", id: "2-3" },
          { name: "Jinan Office", tel: "0531-68803970", id: "2-4" },
          { name: "Zhengzhou Office", tel: "0371-60306707", id: "2-5" },
          { name: "Taiyuan/Inner Mongolia Office", tel: "0351-3336609", id: "2-6" },
          { name: "Foshan Office", tel: "0757-66891888", id: "2-7" },
        ],
      },
      {
        id: 3,
        list: [
          { name: "Xi'an Office", tel: "029-88227067", id: "3-1" },
          { name: "Nanjing Office", tel: "025-87770804", id: "3-2" },
          { name: "Suzhou Office", tel: "0512-65681359", id: "3-3" },
          { name: "Hefei Office", tel: "0551-65604179", id: "3-4" },
          { name: "Wuhan Office", tel: "027-65603032", id: "3-5" },
          { name: "Shijiazhuang Office", tel: "0311-89806988", id: "3-6" },
          { name: "Dongguan Office", tel: "0769-85379892", id: "3-7" },
        ],
      },
      {
        id: 4,
        list: [
          { name: "Chongqing Office", tel: "023-68714273", id: "4-1" },
          { name: "Hunan Office", tel: "0731-85555842", id: "4-2" },
          { name: "Jiangxi Office", tel: "0791-86200012", id: "4-3" },
          { name: "Ningbo Office", tel: "0574-55019950", id: "4-4" },
          { name: "Hangzhou Office", tel: "0571-87830782", id: "4-5" },
          { name: "Wuxi Office", tel: "0510-88772476", id: "4-6" },
          { name: "Huizhou Office", tel: "0752-2555053", id: "4-7" },
        ],
      },
      {
        id: 5,
        list: [
          { name: "Fuzhou Office", tel: "0591-83538269", id: "5-1" },
          { name: "Xiamen Office", tel: "0592-8069292", id: "5-2" },
          { name: "Guizhou Office", tel: "0771-2627323", id: "5-3" },
          { name: "Kunming Office", tel: "0871-63559897", id: "5-4" },
          { name: "Nanning Office", tel: "0771-2627323", id: "5-5" },
          { name: "Nantong Office", tel: "0513-85559006", id: "5-6" },
          { name: "Hainan Office", tel: "0898-66833422", id: "5-7" },
        ],
      },
    ],
    searchTab: {
      title1: "COA SEARCH",
      title2: "MSDS SEARCH",
      title3: "SAFETY LABEL SEARCH",
      title4: "TECHNICAL DATA SHEET SEARCH",
    },
  },
  contact: {
    title: "Contact Us",
    contract: "Contacts",
    contractPhone: "Telephone",
    companyName: "Corporate Name",
    email: "E-mail",
    consultQuestion: "Consultation questions",
    btns: {
      reset: "Reset",
      submit: "Submit",
    },
    cons: {
      title: "contact information",
      companyName: "Xilong Science Co., Ltd",
      address: "Address",
      addressDetail: "No. 6 Xinrui Road, Huangpu District, Guangzhou",
      tel: "Telephone",
      telPhone: "020-62612188",
    },
  },
  search: {
    tabHeader: [
      { name: "Name", id: 1 },
      { name: "validTime", id: 2 },
      { name: "Batch No", id: 3 },
      { name: "CAS No", id: 4 },
      { name: "Description", id: 5 },
      { name: "Operate", id: 6 },
    ],
    detail: "Detail",
  },
  document: {
    search: "Advanced Search",
    inspect: "How to obtain the Quality Inspection Certificate (COA)?",
    enter: "Please enter the inventory name, the batch number and the verification code",
    title: "Please enter the inventory name",
    batchNo: "Please enter the first 6 digits of the batch number",
    cas: "Please enter the cas number",
    code: "Please enter the verification code",
  },
};
